import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UIRouterModule } from '@uirouter/angular';
import { PopoverModule } from 'ngx-bootstrap/popover';

import { ComponentsModule } from '../components/components.module';
import { SchedulesModule } from '../schedules/schedules.module';
import { SharedModule } from '../shared/shared.module';
import { routes } from './displays.routes';

import { ScrollingModule } from '@angular/cdk/scrolling';
import { AccessibilityModule } from '../accessibility';
import { ApiModule } from '../api/api.module';
import { RvBadgeComponent } from '../components/rv-badge/rv-badge.component';
import { FolderPathComponent } from '../components/folders/folder-path/folder-path.component';
import { NewFolderButtonComponent } from '../components/folders/new-folder-button/new-folder-button.component';
import { DialogHeaderComponent } from '../components/modals/dialog-header/dialog-header.component';
import { NoResultsComponent } from '../components/no-results/no-results.component';
import { NotificationAlertComponent } from '../components/notification-alert/notification-alert.component';
import { OperationsMenuComponent } from '../components/operations-menu/operations-menu.component';
import { ScheduleTypePillComponent } from '../components/schedule-type-pill/schedule-type-pill.component';
import { RvDraggableModule } from '../rv-draggable/rv-draggable.module';
import { RotateDirective } from '../shared/directives/rotate/rotate.directive';
import { ActivationNoticeComponent } from './components/activation-notice/activation-notice.component';
import { BulkActivationComponent } from './components/bulk-activation/bulk-activation.component';
import { DisplayAddComponent } from './components/display-add/display-add.component';
import { DisplayAddressComponent } from './components/display-address/display-address.component';
import { DisplayControlComponent } from './components/display-control/display-control.component';
import { DisplayDetailsComponent } from './components/display-details/display-details.component';
import { DisplayFieldsComponent } from './components/display-fields/display-fields.component';
import { DisplayLicenseCountsComponent } from './components/display-license-counts/display-license-counts.component';
import { DisplayListComponent } from './components/display-list/display-list.component';
import { DisplayPreviewComponent } from './components/display-preview/display-preview.component';
import { DisplayStatusComponent } from './components/display-status/display-status.component';
import { EditAddressComponent } from './components/edit-address/edit-address.component';
import { EditAlertVolumeComponent } from './components/edit-alert-volume/edit-alert-volume.component';
import { EditMonitoringComponent } from './components/edit-monitoring/edit-monitoring.component';
import { EditKeyOperationModeComponent } from './components/edit-key-operation-mode/edit-key-operation-mode.component';
import { EditRebootTimeComponent } from './components/edit-reboot-time/edit-reboot-time.component';
import { EditScreenSharingComponent } from './components/edit-screen-sharing/edit-screen-sharing.component';
import { FirmwareUpdateNotificationsComponent } from './components/firmware-update-notifications/firmware-update-notifications.component';
import { InstallComponent } from './components/install/install.component';
import { InteractiveLicenseCountsComponent } from './components/interactive-license-counts/interactive-license-counts.component';
import { LicenseIconComponent } from './components/license-icon/license-icon.component';
import { ScreenshotComponent } from './components/screenshot/screenshot.component';
import { ResolutionPipe } from './pipes/resolution.pipe';
import { provideDisplayFolderOperationService } from './providers/display-folder-operation.provider';
import { DisplayService } from './services/display.service';
import { ViewportComponent } from './viewport/viewport.component';
import { FocusOutlineDirective } from '../accessibility/directives/focus-outline/focus-outline.directive';
import { ActionLinkDirective } from '../accessibility/directives/action-link/action-link.directive';

@NgModule({
  declarations: [
    DisplayAddComponent,
    DisplayLicenseCountsComponent,
    DisplayControlComponent,
    DisplayListComponent,
    DisplayAddressComponent,
    DisplayFieldsComponent,
    FirmwareUpdateNotificationsComponent,
    ScreenshotComponent,
    ResolutionPipe,
    DisplayDetailsComponent,
    ViewportComponent,
    ActivationNoticeComponent,
    EditAddressComponent,
    EditAlertVolumeComponent,
    EditRebootTimeComponent,
    EditMonitoringComponent,
    EditKeyOperationModeComponent,
    BulkActivationComponent,
    InstallComponent,
    DisplayPreviewComponent,
    EditScreenSharingComponent,
    LicenseIconComponent,
    InteractiveLicenseCountsComponent,
  ],
  providers: [
    { provide: 'HasFolderStructure', useClass: DisplayService },
    provideDisplayFolderOperationService(),
  ],
  imports: [
    ActionLinkDirective,
    CommonModule,
    FormsModule,
    UIRouterModule.forChild(routes),
    ApiModule,
    ComponentsModule,
    SchedulesModule,
    SharedModule,
    BrowserAnimationsModule,
    PopoverModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatDialogModule,
    MatButtonModule,
    MatTabsModule,
    MatRadioModule,
    MatSelectModule,
    MatMenuModule,
    MatSliderModule,
    MatFormFieldModule,
    MatInputModule,
    NotificationAlertComponent,
    ScrollingModule,
    MatSlideToggleModule,
    DisplayStatusComponent,
    ScheduleTypePillComponent,
    RotateDirective,
    NoResultsComponent,
    NewFolderButtonComponent,
    FolderPathComponent,
    OperationsMenuComponent,
    AccessibilityModule,
    RvDraggableModule,
    DialogHeaderComponent,
    RvBadgeComponent,
    FocusOutlineDirective,
  ],
})
export class DisplaysModule {}
